import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { TripCategory } from "redmond";
import { useChfarSearchedFlight } from "./useChfarSearchedFlight";

export const useChfarExerciseParams = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const itineraryId = params.get("itineraryId");
  const contractId = params.get("contractId");
  const flightShopType = params.get("flightShopType");

  const origin = params.get("origin");
  const departureDate = params.get("departureDate");
  const originRegionType = params.get("originRegionType");
  const destination = params.get("destination");
  const returnDate = params.get("returnDate");
  const destinationRegionType = params.get("destinationRegionType");

  const { searchDateParams, searchRouteParams } = useChfarSearchedFlight(
    itineraryId ?? "",
    contractId ?? ""
  );

  const tripCategory =
    returnDate || searchDateParams.returnDate
      ? TripCategory.ROUND_TRIP
      : TripCategory.ONE_WAY;

  return useMemo(
    () => ({
      itineraryId,
      contractId,
      origin: origin || searchRouteParams.origin,
      originRegionType: originRegionType || searchRouteParams.originRegionType,
      departureDate: departureDate || searchDateParams.departureDate,
      destination: destination || searchRouteParams.destination,
      destinationRegionType:
        destinationRegionType || searchRouteParams.destinationRegionType,
      returnDate: returnDate || searchDateParams.returnDate,
      tripCategory,
      flightShopType,
    }),
    [
      itineraryId,
      contractId,
      origin,
      originRegionType,
      departureDate,
      searchRouteParams.origin,
      searchRouteParams.originRegionType,
      searchDateParams.departureDate,
      destination,
      destinationRegionType,
      returnDate,
      searchRouteParams.destination,
      searchRouteParams.destinationRegionType,
      searchDateParams.returnDate,
      tripCategory,
      flightShopType,
    ]
  );
};
